export function sortSections(sections) {
  return sections.sort((a, b) => {
    const isAlphaA = /^[A-Z]$/.test(a.section);
    const isAlphaB = /^[A-Z]$/.test(b.section);

    if (isAlphaA && isAlphaB) {
      return a.section.localeCompare(b.section);
    } else if (isAlphaA) {
      return -1;
    } else if (isAlphaB) {
      return 1;
    } else {
      return a.section.localeCompare(b.section);
    }
  });
}

const sortedGrades = {
  "NURSERY":1,
  "LKG":2,
  "UKG":3,
  "I":4,
  "II":5,
  "III":6,
  "IV":7,
  "V":8,
  "VI":9,
  "VII":10,
  "VIII":11,
  "IX":12,
  "X":13,
  "XI":14,
  "XII":15
}
function getGradeInt(gradeName) {
  const [grade] = gradeName.split(" ");
  return sortedGrades[(grade || "").toUpperCase()] || -1
}

// Define custom order for non-numeric grades
export function sortGrades(grades) {
  // helper to compare by name (case insensitive)
  const compareByName = (a, b, key) => {
    const nameA = (a[key] || "").toString().toLowerCase();
    const nameB = (b[key] || "").toString().toLowerCase();
    return nameA.localeCompare(nameB, "en", { numeric: true });
  };

  return grades
    .map(grade => ({
      ...grade,
      sections: [...(grade.sections || [])].sort((a, b) =>
        compareByName(a, b, "section")
      ),
      subjects: [...(grade.subjects || [])].sort((a, b) =>
        compareByName(a, b, "subject")
      )
    }))
    .sort((a, b) => {
      const aNum = getGradeInt(a.grade);
      const bNum = getGradeInt(b.grade);
      return aNum - bNum
    });
}
